import React from 'react';
import { Route } from '@americanexpress/one-app-router';
import { withAppGuard } from './client/components/VrpDashboard/AppRouteGuard';
import TablePage from './client/components/VrpDashboard/TablePage';
import Home from './client/components/VrpDashboard/Home';
import ErrorScreen from './client/components/ErrorScreen';
import NotFoundScreen from './client/components/NotFoundScreen';

const EntryRouteComponent = () => null;

const childRoutes = () => [
  <Route key="/" path="/" component={withAppGuard(EntryRouteComponent)} />,
  <Route key="/table" path="/table" component={withAppGuard(TablePage)} />,
  <Route key="/welcome" path="/welcome" component={withAppGuard(Home)} />,
  <Route key="/error" path="/error" component={withAppGuard(ErrorScreen)} />,
  <Route key="/notFound" path="/notFound" component={withAppGuard(NotFoundScreen)} />,
  <Route key="*" path="*" component={withAppGuard(NotFoundScreen)} />,
];

export default childRoutes;
